// extracted by css-extract-rspack-plugin
var _1 = "yg";
export { _1 as "errorContainerComponent" }
